import { CSSObject } from '@emotion/react';
import { makeStyles } from 'tss-react/mui';
import { authBackgroundStyle } from '../../styles/authBackground.styles';

interface LoginFormStyleParams {
  background?: string;
}

const useLoginFormStyles = makeStyles<LoginFormStyleParams>()((theme, { background }) => ({
  root: {
    maxWidth: theme.spacing(40),
  },
  background: authBackgroundStyle(theme, background) as CSSObject,
  paper: {
    margin: theme.spacing(2),
    padding: theme.spacing(4),
    borderRadius: theme.spacing(2),
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.primary.main,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
    maxWidth: theme.spacing(40),
    width: '100%',
  },
  redirectLink: {
    textDecoration: 'underline',
    color: theme.palette.common.white,
  },
}));

export default useLoginFormStyles;
